export const UPLOAD_FILE           = 'formSupplier/UPLOAD_FILE'
export const UPLOAD_FILE_COMPLETED = 'formSupplier/UPLOAD_FILE_COMPLETED'
export const UPLOAD_FILE_FAILED    = 'formSupplier/UPLOAD_FILE_FAILED'
